import { useContext, useState, useEffect } from 'react';
import {
  GameStateContext,
  LinkRowRefContext,
} from '../../Providers/GameStates/GameState.jsx';
import { Box, useTheme } from '@mui/material';
import RowChain, { getChangedIndex } from './RowChain.jsx';

function Upper() {
  const { state } = useContext(GameStateContext);
  const { goldenIndices, lastAdded } = useContext(GameStateContext);
  const theme = useTheme();
  const [renderedWords, setRenderedWords] = useState([]);
  const { ref: linkRowRef, centerLinkDiv } = useContext(LinkRowRefContext);
  const completedLinkIndex = state.won
    ? getChangedIndex(state.upper[state.upper.length - 1]?.[0], state.link)
    : -1;

  useEffect(() => {
    if (!state.isInitialized || !Array.isArray(state.upper)) {
      return;
    }
    setRenderedWords(state.upper.map((item) => item[0]));
  }, [state.upper, state.isInitialized]);

  useEffect(() => {
    if (!state.isInitialized) {
      return;
    }
    centerLinkDiv(linkRowRef);
  }, [state.wordLength, state.isInitialized]);

  return (
    state.upper && (
      <>
        {state.upper.map((item, index) => (
          <Box
            sx={{
              ...theme.custom.letterRow,
              '--step-color': theme.palette.primary.main,
            }}
            key={index}
            className={`word-row ${
              lastAdded == 'upper' && index === state.upper.length - 1
                ? 'word-row--slide-down'
                : ''
            }`}
          >
            <RowChain
              wordLength={state.wordLength}
              incomingIndex={index > 0 ? item[1][0] : null}
              outgoingIndex={
                index < state.upper.length - 1
                  ? state.upper[index + 1][1][0]
                  : state.won
                  ? completedLinkIndex
                  : null
              }
            />
            {[...item[0]].map((letter, j) => (
              <Box
                key={j}
                sx={{
                  ...theme.custom.letterBox, // Reuse letter box styles
                  '--aura-color': theme.custom.aura,
                  backgroundColor:
                    index === 0
                      ? theme.palette.primary.main
                      : theme.custom.incorrect,
                  border: `1px solid ${theme.custom.border}`,
                  color: theme.palette.text.primary,
                }}
                className={`letter-box ${
                  (index === 0 &&
                    state.upper.length > 1 &&
                    state.upper[1][1][0] === j) ||
                  (index > 0 && item[1][0] === j)
                    ? 'letter-box--step-node'
                    : ''
                } ${
                  index === state.upper.length - 1 &&
                    ((state.won && completedLinkIndex === j) ||
                      (!state.won && goldenIndices.includes(j)))
                    ? 'letter-box--chain-node letter-box--chain-upper'
                    : ''
                }`}
              >
                {letter}
              </Box>
            ))}
          </Box>
        ))}
      </>
    )
  );
}

export default Upper;
